import React, { useCallback } from 'react'
import { Col, Form, Row, Typography } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { FormButtons, FormInput } from '../../../common/components/sections'
import {
  StyledPageActions,
  StyledPageHeader,
  StyledPageTitle,
} from '../../../common/components/styled'
import { PERMISSIONS } from '../../../common/constants'
import { useFormDirty } from '../../../common/hooks'

const SopCreateForm = ({ onSubmit, isLoading, error }) => {
  const [form] = Form.useForm()
  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const onFinish = useCallback(
    sop => onSubmit(sop, resetForm),
    [onSubmit, resetForm],
  )

  return (
    <Form
      form={form}
      name="createSop"
      onFinish={onFinish}
      autoComplete="off"
      onFieldsChange={setToDirty}
      onReset={resetForm}
    >
      <StyledPageHeader sticky>
        <StyledPageTitle>Create SOP</StyledPageTitle>
        <StyledPageActions>
          <FormButtons
            permissions={[PERMISSIONS.SOP.CREATE]}
            isDisabled={!isDirty}
            isLoading={isLoading}
          />
        </StyledPageActions>
      </StyledPageHeader>
      <Row gutter={[16, 16]}>
        <Col span={5}>
          <FormInput
            name="name"
            label="Name"
            labelAbove
            placeholder="Input name..."
            rules={[
              {
                required: true,
              },
            ]}
          />
        </Col>
        <Col span={5}>
          <FormInput
            name="link"
            label="Link"
            labelAbove
            placeholder="Input link..."
            rules={[
              {
                required: true,
                type: 'url',
              },
            ]}
          />
        </Col>
        {!isNil(error) && (
          <Col span={24}>
            <Typography.Paragraph type="danger">{error}</Typography.Paragraph>
          </Col>
        )}
      </Row>
    </Form>
  )
}

SopCreateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
}

SopCreateForm.defaultProps = {
  error: null,
}

export default SopCreateForm
